import { render, staticRenderFns } from "./ReferralLinks.vue?vue&type=template&id=2946b4c7&scoped=true"
import script from "./ReferralLinks.vue?vue&type=script&lang=js"
export * from "./ReferralLinks.vue?vue&type=script&lang=js"
import style0 from "./ReferralLinks.vue?vue&type=style&index=0&id=2946b4c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946b4c7",
  null
  
)

export default component.exports